import React from 'react';

const AppHeader = React.memo(() => (
  <header className="layout-header">
    <h1>Weatherings</h1>
  </header>
));

export default AppHeader;
